;
define("error_management_forbidden_error.tpl", function(){});

